<yc-modal *ngIf="isAfterInit"
  [ycHidden]="createBudgetModalOpen"
  [formGroup]="formGroup"
  [modalHeader]="modalHeader"
  [modalSubHeader]="modalSubHeader">

  <div [ycHidden]="isBudgetView">
    <!-- Name -->
    <div class="mb-3">
      <yc-input
        name="name"
        [label]="'common:lblName' | ycI18n: 'Name'">
      </yc-input>
    </div>

    <!-- Dates -->
    <div>
      <div class="font-875-rem font-550 mb-2">
        <yc-i18n
          key="GLOBAL:textDuration"
          defaultValue="Duration">
        </yc-i18n>
      </div>
      
      <!-- Always Open -->
      <div *ngIf="otherCycles.length === 0">
        <yc-checkbox
          name="alwaysOpen"
          [optionLabel]="'common:textAlwaysOpen' | ycI18n: 'Always open'"
          (onChange)="alwaysOpenChange($event)">
        </yc-checkbox>
      </div>

      <div [ycHidden]="formGroup.value.alwaysOpen" 
        class="d-flex">
        <!-- Start Date -->
        <div class="d-flex flex-fill">
          <div class="flex-fill">
            <yc-datepicker
              name="startDate"
              [label]="'GLOBAL:textStartDateAndTime' | ycI18n: 'Start date and time'"
              (onChange)="datesChanged()">
            </yc-datepicker>
            </div>
            <div class="flex-fill">
              <yc-time-input
                name="startTime"
                (onChange)="datesChanged()">
              </yc-time-input>
            </div>
        </div>

        <!-- End Date -->
        <div class="d-flex flex-fill">
          <div class="flex-fill">
            <yc-datepicker
              name="endDate"
              [label]="'GLOBAL:textEndDateAndTime' | ycI18n: 'End date and time'"
              (onChange)="datesChanged()">
            </yc-datepicker>
          </div>
          <div class="flex-fill">
            <yc-time-input
              name="endTime"
              (onChange)="datesChanged()">
            </yc-time-input>
          </div>
        </div>
      </div>

      <!-- Cycle Overlap -->
      <div *ngIf="cycleDatesOverlap">
        <yc-alert
          [message]="'PROGRAM:textCycleDatesOverlapAlert' | ycI18n: 'The dates and times below conflict with another cycle. Cycle dates cannot overlap.'"
          alertClass="warning">
        </yc-alert>
      </div>
    </div>

    <!-- Budgets and Processing -->
    <div *ngIf="!isNomination">
      <div class="details-header mt-3">
        <yc-i18n
          key="BUDGET:hdrBudgetsAndProcessing"
          defaultValue="Budgets and Processing">
        </yc-i18n>
      </div>

      <div class="details-subheader">
        <yc-i18n
          [key]="hideFundingSources ?
            'BUDGET:textSelectCycleBudgetsHelp' :
            'BUDGET:textSelectCycleBudgetFsHelp'"
          [defaultValue]="hideFundingSources ?
            'Select the budgets to make available for awards and payments created during this cycle. From the available budgets, specify the default budgets to use for all cash and in-kind payments.' :
            'Select the budgets to make available for awards and payments created during this cycle. From the available budgets, specify the default budget and funding source combinations to use for all cash and in-kind payments.'">
        </yc-i18n>
      </div>

      <!-- Select Budgets Action -->
      <div class="mt-3 mb-3">
        <yc-button
          [secondary]="true"
          [fontAwesomeIcon]="'plus'"
          [langKey]="'BUDGET:textSelectCycleBudgets'"
          [defaultText]="'Select cycle budgets'"
          (onClick)="isBudgetViewChange(true)">
        </yc-button>
      </div>

      <!-- Current Budgets Selected -->
      <yc-tags [ycHidden]="formGroup.value.budgets.length === 0"
        [placeholder]="''"
        [secondaryPlaceholder]="''"
        [autocompleteItems]="budgetOptions"
        [name]="'budgets'"
        (onChange)="budgetsChanged()">
      </yc-tags>

      <div *ngIf="showDefaultCashBudgetOptions"
        class="mb-3 mt-3 d-flex">
        <!-- Default Cash Budget ID -->
        <yc-typeahead-select
          class="flex-basis-50 me-2"
          name="defaultCashBudgetId"
          [items]="budgetCashOptions"
          [label]="'BUDGET:textDefaultCashBudget' | ycI18n: 'Default cash budget'"
          [showClear]="false"
          (onChange)="onDefaultCashBudgetChange(true)">
        </yc-typeahead-select>

        <!-- Default Cash Funding Source ID-->
        <yc-typeahead-select *ngIf="!!formGroup.value.defaultCashBudgetId && !hideFundingSources"
          class="flex-basis-50"
          name="defaultCashFundingSourceId"
          [items]="fsCashOptions"
          [label]="'BUDGET:textDefaultCashFundingSource' | ycI18n: 'Default cash funding source'"
          [showClear]="false">
        </yc-typeahead-select>
      </div>

      <div *ngIf="showDefaultInKindBudgetOptions"
        class="mb-3 d-flex">
        <!-- Default In-Kind Budget ID -->
        <yc-typeahead-select
          class="flex-basis-50 me-2"
          name="defaultInKindBudgetId"
          [items]="budgetInKindOptions"
          [label]="'BUDGET:textDefaultInKindBudget' | ycI18n: 'Default in-kind budget'"
          [showClear]="false"
          (onChange)="onDefaultInKindBudgetChange(true)">
        </yc-typeahead-select>

        <!-- Default In-Kind FS ID -->
        <yc-typeahead-select *ngIf="!!formGroup.value.defaultInKindBudgetId && !hideFundingSources"
          class="flex-basis-50"
          name="defaultInKindFundingSourceId"
          [items]="fsInKindOptions"
          [label]="'BUDGET:textDefaultInKindFundingSource' | ycI18n: 'Default in-kind funding source'"
          [showClear]="false">
        </yc-typeahead-select>
      </div>

      <div [ycHidden]="!showProcessorDropdown"
        class="d-flex mt-2">
        <yc-typeahead-select
          class="flex-basis-50" 
          name="clientOrganizationsProcessingTypeId"
          [placeholder]="'common:lblDashedPleaseSelect' | ycI18n"
          [label]="'PROGRAM:lblSelectProcessorForIneligibleOrgs' | ycI18n:'Select processor for organizations ineligible for YourCause processing'"
          [items]="processorOptions"
          [showClear]="false">
        </yc-typeahead-select>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!isNomination">
    <div [ycHidden]="!isBudgetView">
      <gc-cycle-budget-selector
        [budgetIds]="cycleBudgets"
        [isIndividual]="isIndividual"
        (onBudgetsChanged)="onBudgetsChangedFromSelector($event)">
      </gc-cycle-budget-selector>
    </div>
  </ng-container>

  <!-- Modal Footer -->
  <div *ycModalFooter
    class="modal-footer">
    <div class="flex-grow-1 d-flex full-width align-items-center">
      <div class="d-flex align-items-center add-border-right">
        <!-- Primary Button -->
        <yc-button
          class="me-3"
          [primary]="true"
          [langKey]="isBudgetView ? 'search:textSelect' : 'common:btnSave'"
          [defaultText]="isBudgetView ? 'Select' : 'Save'"
          [disabled]="isBudgetView ? cycleBudgets.length === 0 : (formGroup.invalid || cycleDatesOverlap)"
          (onClick)="isBudgetView ? selectBudgets() : onSave()">
        </yc-button>

        <!-- Secondary Button -->
        <yc-button *ngIf="isBudgetView && hideFundingSources"
          class="me-3"
          [secondary]="true"
          [langKey]="'common:textNewBudget'"
          [defaultText]="'New budget'"
          (onClick)="onNewBudget()">
        </yc-button>

        <!-- Cancel Button -->
        <yc-button
          class="me-3"
          [link]="true"
          [langKey]="'common:btnCancel'"
          [defaultText]="'Cancel'"
          (onClick)="isBudgetView ? cancelBudgetSelection() : closeModal.emit()">
        </yc-button>
      </div>

      <div *ngIf="!isNomination"
        class="ms-5 d-flex">
        <!-- Number of Budgets -->
        <div class="d-flex flex-column me-5">
          <div class="font-875-rem">
            <yc-i18n
              [key]="'GLOBAL:textBudgets'"
              [defaultValue]="'Budgets'">
            </yc-i18n>
          </div>
          <strong class="font-875-rem">
            {{ cycleBudgets.length }}
          </strong>
        </div>

        <!-- Available For Payments -->
        <div class="d-flex flex-column">
          <div class="font-875-rem">
            <yc-i18n
              [key]="'common:textAvailableForPayments'"
              [defaultValue]="'Available for payments'">
            </yc-i18n>
          </div>
          <strong class="font-875-rem">
            {{ (cycleBudgets | gcSumTotalAvailable) | gcMoney }}
          </strong>
        </div>
      </div>
    </div>
  </div>
</yc-modal>